import React, { useEffect, useState, useContext } from 'react'
import db from '../auth/fireDb'
import image from '../images/image.png'
import { NavLink } from 'react-router-dom'
import { store } from 'react-notifications-component'
import { useHistory } from 'react-router-dom'
import { AuthContext } from '../auth/auth'


const Contact = () => {
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")
    const [name, setName] = useState("")
    const [mobile, setMobile] = useState("")
    const history = useHistory();
    const { currentUser } = useContext(AuthContext);

    // if (currentUser) {
    //     setEmail(currentUser.email)
    // }

    function handleEmail(event) {
        setEmail(event.target.value);
    }
    function handleName(event) {
        setName(event.target.value);
    }
    function handleMobile(event) {
        setMobile(event.target.value);
    }
    function handleMessage(event) {
        setMessage(event.target.value);
    }

    useEffect(() => {
        document.title = "CareerGrads | Contact-Us"
    }, [])

    const notifyPopup = () => {
        store.addNotification({
            title: "Success!",
            message: "Message Sent! We will Contact You Soon.",
            type: "warning",
            background: "pink",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 3000,
                onScreen: true,
            },
        });
    };
    const notifyPopupLogin = () => {
        store.addNotification({
            title: "Please Log!",
            message: "You need to Login First",
            type: "danger",
            background: "pink",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 3000,
                onScreen: true,
            },
        });
    }
    const handlePost = (event) => {
        if (currentUser) {
            event.preventDefault();
            db.collection("contact-form").add({
                email,
                message,
                name,
                mobile
            })
                .then((docRef) => {
                    notifyPopup()
                    history.push('/')
                    setEmail("")
                    setName("")
                    setMessage("")
                    setMobile("")
                })
                .catch((error) => {
                    console.error("Error adding document: ", error);
                });
        } else {
            notifyPopupLogin()
            history.push('/login')
        }
    }

    return (
        <>
            <div className="my-5">
                <div className="text-center my-4">
                    <h1>
                        <strong>Get In Touch!</strong>
                    </h1>
                </div>
                <div className="container-fluid" >
                    <div className="row">
                        <div className="col-10 mx-auto">
                            <div className="container " >
                                <div className="row">
                                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xs-offset-3 ">
                                        <img src={image} alt="image" className="img-fluid img-responsive" />
                                    </div>
                                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xs-offset-3 my-auto text-center ">
                                        <h4 >
                                            Our Courses and Trainings not only helps the students
                                            to upskill themselves but also provides
                                                <span className=" text-primary font-weight-bold "
                                                style={{ fontFamily: 'Dancing Script', fontSize: "2.6rem" }}> Job/Internships </span>
                                                    for an industrial exposure.
                                            </h4>
                                        <NavLink className="btn btn-secondary mt-4 p-2 " to='/reviews'>
                                            Success Stories!
                                            </NavLink>

                                    </div>
                                </div>

                                <div className="container-fluid my-5 card shadow">
                                    <h3 className="my-4 ">
                                        Drop us a Message!
                                        </h3>
                                    <form id="contact-form" className="form my-4" role="form" onSubmit={handlePost}>
                                        <div class="form-group">
                                            <label className="form-label  font-weight-bold" for="name">Your Name</label>
                                            <input type="text" className="form-control  " id="name" name="name" placeholder="Your name" tabindex="1" required onChange={handleName} />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label font-weight-bold" for="email">Your Email</label>
                                            <input type="email" className="form-control" id="email" name="email" placeholder="Your Email" tabindex="2" required onChange={handleEmail} />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label font-weight-bold" for="subject">Mobile</label>
                                            <input type="text" className="form-control" id="subject" name="subject" placeholder="Mobile" tabindex="3" typeof="number" required onChange={handleMobile} />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label font-weight-bold" for="message">Message</label>
                                            <textarea rows="5" cols="50" name="message" className="form-control" id="message" placeholder="Message..." tabindex="4" required onChange={handleMessage}></textarea>
                                        </div>
                                        <div className="text-center ">
                                            <button className="btn btn-block bg-primary text-white mt-4 btn-start-order btn-explore" type="submit">Send Message</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* {
                window.scrollTo(0, 0)
            } */}
        </>
    )
}

export default Contact
